import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ModalState {
  showPlaylistModal: boolean
  playlistModalSource: string
  showInviteModal: boolean
  showInviteListModal: boolean
  showInviteListStateModal: boolean
  showReleaseErrorModal: boolean
  releaseErrorTitle: string
  releaseErrorMessage: string
  showSignoutModal: boolean
  showClearQueueModal: boolean
  showShareReleaseModal: boolean
  showResetPasswordConfirmationModal: boolean
  showSignoutAllSessionsModal: boolean
  showConnectEmailModal: boolean
}

const initialState: ModalState = {
  showPlaylistModal: false,
  playlistModalSource: 'unknown',
  showInviteModal: false,
  showInviteListModal: false,
  showInviteListStateModal: false,
  showReleaseErrorModal: false,
  releaseErrorTitle: '',
  releaseErrorMessage: '',
  showSignoutModal: false,
  showClearQueueModal: false,
  showShareReleaseModal: false,
  showResetPasswordConfirmationModal: false,
  showSignoutAllSessionsModal: false,
  showConnectEmailModal: false,
}

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openPlaylistModal: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.showPlaylistModal = true
      state.playlistModalSource = action.payload || 'unknown'
    },
    closePlaylistModal: (state) => {
      state.showPlaylistModal = false
      state.playlistModalSource = 'unknown'
    },
    togglePlaylistModal: (state) => {
      state.showPlaylistModal = !state.showPlaylistModal
      if (!state.showPlaylistModal) {
        state.playlistModalSource = 'unknown'
      }
    },
    toggleInviteModal: (state) => {
      state.showInviteModal = !state.showInviteModal
    },
    toggleInviteListModal: (state) => {
      state.showInviteListModal = !state.showInviteListModal
    },
    toggleInviteListStateModal: (state) => {
      state.showInviteListStateModal = !state.showInviteListStateModal
    },
    toggleSignoutModal: (state) => {
      state.showSignoutModal = !state.showSignoutModal
    },
    toggleClearQueueModal: (state) => {
      state.showClearQueueModal = !state.showClearQueueModal
    },
    toggleShareReleaseModal: (state) => {
      state.showShareReleaseModal = !state.showShareReleaseModal
    },
    toggleResetPasswordConfirmationModal: (state) => {
      state.showResetPasswordConfirmationModal = !state.showResetPasswordConfirmationModal
    },
    toggleSignoutAllSessionsModal: (state) => {
      state.showSignoutAllSessionsModal = !state.showSignoutAllSessionsModal
    },
    toggleConnectEmailModal: (state) => {
      state.showConnectEmailModal = !state.showConnectEmailModal
    },
    setReleaseError: {
      prepare(title: string, message: string) {
        return { payload: { title, message } }
      },
      reducer(state, action: PayloadAction<{ title: string; message: string }>) {
        state.showReleaseErrorModal = true
        state.releaseErrorTitle = action.payload.title
        state.releaseErrorMessage = action.payload.message
      },
    },
    dismissReleaseError: (state) => {
      state.showReleaseErrorModal = false
      state.releaseErrorTitle = ''
      state.releaseErrorMessage = ''
    },
  },
})

export const modalActions = modalSlice.actions
export const modalReducer = modalSlice.reducer
export default modalActions
